import { InferType, number, object, string } from 'yup'

import { report } from './logging/logging'
import { ExclusionState } from 'components/Exclusion/exclusion.type'

const knownErrorSchema = object({
  status: number().oneOf([400]).required(),
  data: object({
    errorCode: string().required(),
    payload: object({
      channel: string().optional(),
      exclusionCode: string().optional(),
      originalInceptionDate: string().optional(),
      vehicleType: string().optional(),
      firstQuoteId: string().optional(),
      email: string().optional(),
      dateOfBirth: string().optional(),
      postalCode: string().optional(),
    }).optional(),
  }).required(),
})

type KnownErrorObject = InferType<typeof knownErrorSchema>

export const isKnownQuoteErrorObject = (value: unknown): value is KnownErrorObject => {
  const isValid = knownErrorSchema.isValidSync(value)

  return isValid
}

type isAcceptedExclusionErrorResult = {
  data: { payload: Omit<ExclusionState, 'quoteId'> }
}

export const isAcceptedExclusionError = (
  error: unknown,
): error is KnownErrorObject & isAcceptedExclusionErrorResult => {
  const assertedError = error as { data: { errorCode: string; payload: Partial<ExclusionState> } }
  const isNotDeclineErrorCode = assertedError?.data?.errorCode !== 'QUOTE_DECLINED'

  if (!isKnownQuoteErrorObject(error)) {
    const alternateError = error as { status: number }
    report(error, 'Exclusion - is not known error object', {
      args: { errorCode: assertedError?.data?.errorCode, status: alternateError?.status },
    })
    return false
  }
  if (isNotDeclineErrorCode) {
    report(error, 'Exclusion - errorCode is not QUOTE_DECLINED')
    return false
  }
  if (!isExclusionState(assertedError?.data?.payload)) {
    report(error, 'Exclusion - error payload is missing exclusion state', {
      args: assertedError.data.payload,
    })
    return false
  }

  return true
}

const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}

const isExclusionState = (state: Partial<ExclusionState>): state is ExclusionState => {
  return (
    isString(state.exclusionCode) &&
    isString(state.vehicleType) &&
    isString(state.firstQuoteId) &&
    isString(state.email) &&
    isString(state.dateOfBirth) &&
    isString(state.postalCode) &&
    isString(state.channel)
  )
}
